// Mock data for Akira Signature Care Medical Spa

export const SERVICES = [
  // ── AESTHETICS ────────────────────────────────────────────────────────────
  {
    id: 1,
    title: 'XERF Structural Tightening',
    subtitle: 'RF Skin Tightening',
    tag: 'FDA Cleared',
    description: 'FDA-cleared radiofrequency tightening that uses dynamic temperature control to safely heat up to 42°C, targeting the dermis and SMAS layer. Stimulates natural collagen and elastin for visibly tighter skin — with little to no downtime.',
    image: '/xerf.jpg',
    features: ['Dynamic Temperature Control to 42°C', 'Wave Fit™ Pulse Technology', 'Never-Numb™ — No Topical Anesthetic', 'All Skin Types & Tones'],
    category: 'aesthetics',
    badge: null
  },
  {
    id: 3,
    title: 'Skin Microneedling',
    subtitle: 'Collagen Induction Therapy',
    tag: 'Gold Standard',
    description: "Controlled micro-channels activate your skin's own collagen and elastin response — refining texture, softening scars, and brightening tone without injectable filler.",
    image: '/skin-microneedling.jpg',
    features: ['Refined Skin Texture', 'Softer Acne Scars', 'Smaller-Looking Pores', 'More Even Tone'],
    category: 'aesthetics',
    badge: null
  },
  {
    id: 12,
    title: 'RF Microneedling',
    subtitle: 'Microneedling + Radiofrequency',
    tag: 'Advanced',
    description: 'Combines insulated microneedles with controlled bipolar radiofrequency to remodel collagen at deeper layers — ideal for advanced texture, scarring, and early-to-moderate laxity concerns.',
    image: 'https://images.pexels.com/photos/3762871/pexels-photo-3762871.jpeg?w=600&q=80',
    features: ['Deeper Collagen Remodeling', 'Smoother Acne Scars', 'Improved Firmness', 'Refined Skin Texture'],
    category: 'aesthetics',
    badge: null
  },
  {
    id: 13,
    title: 'Thulium Laser',
    subtitle: 'Fractional Skin Resurfacing',
    tag: 'Fractional Laser',
    description: 'Fractional 1927nm laser resurfacing that creates thousands of microscopic treatment zones to renew skin from within — reducing fine lines, age spots, sun damage, and acne scars with a faster recovery than traditional CO2.',
    image: '/thulium-laser.jpg',
    features: ['1927nm Fractional Wavelength', 'Customisable Depth & Intensity', 'Compatible with Broader Skin Tones', 'Faster Recovery than CO2'],
    category: 'aesthetics',
    badge: null
  },
  {
    id: 14,
    title: 'CO2 Laser Resurfacing',
    subtitle: 'Advanced Fractional CO2',
    tag: 'Advanced Resurfacing',
    description: 'One of the most powerful resurfacing treatments available. Fractional CO2 vaporizes damaged layers and triggers robust collagen regeneration — for dramatic improvement in deep wrinkles, sun damage, and scarring.',
    image: '/co2-laser.jpg',
    features: ['Deep Wrinkle Reduction', 'Acne & Surgical Scar Improvement', 'Significant Skin Tightening', 'Often One Treatment Needed'],
    category: 'aesthetics',
    badge: null
  },
  {
    id: 15,
    title: 'IPL Photofacial',
    subtitle: 'Intense Pulsed Light',
    tag: 'Light Therapy',
    description: 'Gentle, non-invasive multi-wavelength light therapy that targets brown spots, redness, broken capillaries, and uneven texture — revealing clearer, more uniform skin with minimal downtime.',
    image: 'https://images.pexels.com/photos/3993454/pexels-photo-3993454.jpeg?w=600&q=80',
    features: ['Sun Spots & Age Spots', 'Rosacea & Redness', 'Broken Capillaries', '15–30 Minute Sessions'],
    category: 'aesthetics',
    badge: null
  },
  {
    id: 16,
    title: 'Microdermabrasion',
    subtitle: 'Gentle Exfoliation',
    tag: 'Express Treatment',
    description: 'A gentle, non-invasive exfoliation that buffs away dull, dead skin and reveals a brighter, smoother surface — with no downtime and instant glow.',
    image: '/microdermabrasion.jpg',
    features: ['Diamond or Crystal Exfoliation', 'Unclogs Pores', 'No Downtime', '30–45 Minute Sessions'],
    category: 'aesthetics',
    badge: null
  },
  {
    id: 17,
    title: 'PRP & PRF Regenerative Therapy',
    subtitle: 'Your Own Growth Factors',
    tag: 'Regenerative',
    description: "Uses growth factors concentrated from your own blood to rejuvenate skin, stimulate collagen, and support recovery — delivered via injection or microneedling to the face, scalp, or under-eye area.",
    image: '/prp-prf-regenerative.jpg',
    features: ['PRP — Immediate Growth Factor Release', 'PRF — Sustained Slow Release', 'Pairs with Microneedling or Laser', 'Under-Eye Hollowness Support'],
    category: 'aesthetics',
    badge: null
  },
  {
    id: 18,
    title: 'PRP Hair Restoration',
    subtitle: 'Non-Surgical Hair Restoration',
    tag: 'Hair Restoration',
    description: 'A non-surgical option that uses concentrated growth factors from your own blood to reactivate dormant follicles, strengthen the scalp, and encourage natural regrowth — for both men and women.',
    image: '/prp-hair-restoration.jpg',
    features: ['Follicle Reactivation', 'Reduced Active Shedding', 'Increased Hair Density', '3–4 Sessions + Maintenance'],
    category: 'aesthetics',
    badge: null
  },
  {
    id: 4,
    title: 'Injectables & Fillers',
    subtitle: 'Neuromodulators · Fillers · Biostimulators',
    tag: 'FDA Approved',
    description: 'FDA-approved injectables administered exclusively by our board-certified medical team. Neuromodulators relax expression lines; hyaluronic acid fillers restore volume; collagen biostimulators encourage your body to build its own collagen over time.',
    image: '/injectables-fillers.jpg',
    features: ['Botox® · Dysport® · Xeomin® · Letybo®', 'Restylane® · Juvéderm® (HA Fillers)', 'Sculptra® · Radiesse® (Biostimulators)', 'Lip · Cheek · Chin · Jawline'],
    category: 'aesthetics',
    badge: null
  },
  {
    id: 5,
    title: 'Advanced Facial / Red Light Therapy',
    subtitle: 'HydraFacial & Customised Red Light',
    tag: null,
    description: 'Three-phase HydraFacial via the IDS Hydro Plus system, paired with customisable red light therapy. Settings can be tailored for acne, fine lines, body contouring, recovery from aches & pains, hair/scalp support, and skin radiance.',
    image: '/hydrafacial.jpg',
    features: ['HydraFacial (IDS Hydro Plus)', 'Customisable Red Light Therapy', 'Vortex-Fusion Booster Serums', 'Suitable for Sensitive Skin'],
    category: 'aesthetics',
    badge: null
  },
  // ── PRECISION HEALTH ──────────────────────────────────────────────────────
  {
    id: 6,
    title: 'Precision Weight Management',
    subtitle: 'GLP-1 Therapy + Metabolic Testing',
    tag: 'FDA Approved',
    description: 'FDA-approved GLP-1 prescription therapy combined with metabolic and body-composition testing. Weekly injection with gradual dose escalation — average 10–15% body-weight loss with sustained physician oversight.',
    image: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=600&q=80',
    features: ['FDA-Approved GLP-1 Medications', 'Weekly Self-Administered Injection', 'Average 10–15% Body-Weight Loss', 'Metabolic & Body Composition Testing'],
    category: 'precision',
    badge: null
  },
  {
    id: 7,
    title: 'Hormone Optimization',
    subtitle: 'Bioidentical Hormone Therapy',
    tag: null,
    description: 'Comprehensive hormone evaluation and personalized optimization for energy, mood, libido, body composition, and long-term vitality — for women and men across every life stage.',
    image: 'https://images.pexels.com/photos/8460346/pexels-photo-8460346.jpeg?w=600&q=80',
    features: ['Comprehensive Hormone Panel', 'Bioidentical Hormone Therapy', 'Thyroid & Adrenal Support', 'Perimenopause & Andropause Care'],
    category: 'precision',
    badge: null
  },
  {
    id: 8,
    title: 'Genetics, Microbiome & Biomarkers',
    subtitle: 'Multi-Omics Analysis',
    tag: null,
    description: 'Comprehensive multi-omics testing combining genetic SNP analysis, Viome microbiome RNA profiling, and 160+ blood biomarkers — the deepest biological snapshot available, with a personalised action plan.',
    image: '/microbiome-genetics.jpg',
    features: ['Genetic SNP Mapping', 'Viome Microbiome RNA Analysis', 'Function Health 160+ Biomarkers', 'Integrated Personalised Protocol'],
    category: 'precision',
    badge: null
  },
  {
    id: 21,
    title: 'Microbiome Deep Dive',
    subtitle: 'Viome PRO — Gut, Oral & Gene Expression',
    tag: 'New',
    description: 'The complete Viome PRO testing kit — three tests covering gut and oral microbiome plus blood-based gene expression — paired with a private consultation to translate every result into a personalised, food-first protocol.',
    image: 'https://images.pexels.com/photos/25626515/pexels-photo-25626515.jpeg?w=600&q=80',
    features: ['Viome PRO Gut Intelligence Test', 'Viome Oral Health Test', 'Viome Blood Gene-Expression Test', 'Expert Results Consultation'],
    category: 'precision',
    badge: null
  },
  {
    id: 9,
    title: 'Functional Medicine',
    subtitle: 'Root-Cause Care',
    tag: null,
    description: 'Whole-person, root-cause medicine for chronic symptoms, fatigue, gut issues, autoimmunity, and inflammation. We treat the system — not just the symptom — with personalised, evidence-based protocols.',
    image: '/functional-medicine.jpg',
    features: ['Gut & Microbiome Health', 'Inflammation & Autoimmunity', 'Detoxification Support', 'Nutrition & Supplement Strategy'],
    category: 'precision',
    badge: null
  },
  {
    id: 10,
    title: 'Longevity Medicine',
    subtitle: 'Quality-of-Life Optimization',
    tag: null,
    description: 'Concierge-level longevity programme integrating biological age testing, advanced biomarkers, and targeted interventions to improve long-term quality of life — so the years ahead are years you actually want to live.',
    image: 'https://images.pexels.com/photos/8939960/pexels-photo-8939960.jpeg?w=600&q=80',
    features: ['Biological Age Testing', 'Advanced Cardiometabolic Panel', 'Targeted Longevity Protocols', 'Ongoing Physician Coaching'],
    category: 'precision',
    badge: null
  },
  {
    id: 19,
    title: 'VISIA Skin Analysis',
    subtitle: 'Multi-Spectral Skin Imaging',
    tag: 'Precision Imaging',
    description: 'Advanced digital imaging by Canfield that maps surface and subsurface skin conditions across 8 parameters — including a personalised TruSkin Age — to design and track your treatment plan objectively.',
    image: '/visia-skin-analysis.jpg',
    features: ['8-Parameter Skin Analysis', 'UV + Cross-Polarised Imaging', 'TruSkin Age Score', 'Objective Progress Tracking'],
    category: 'precision',
    badge: null
  },
  {
    id: 20,
    title: 'Body Composition Analysis',
    subtitle: 'Bioelectrical Impedance Assessment',
    tag: 'Precision Imaging',
    description: 'Safe, painless bioelectrical impedance assessment that measures muscle mass, body-fat percentage, visceral fat, hydration, and basal metabolic rate — giving objective data to guide weight, fitness, and longevity goals.',
    image: '/body-composition.jpg',
    features: ['Body Fat % & Lean Muscle Mass', 'Visceral Fat Assessment', 'Basal Metabolic Rate', 'Segmental Analysis (Arms, Legs, Trunk)'],
    category: 'precision',
    badge: null
  },
  // ── WELLNESS SUPPORT ──────────────────────────────────────────────────────
  {
    id: 11,
    title: 'Akira Infusion Therapy',
    subtitle: 'Intravenous Nutrient Drips',
    tag: null,
    description: 'Targeted IV vitamin, mineral, and antioxidant infusions for hydration, recovery, immunity, energy, and skin radiance — delivered directly to your bloodstream for maximum absorption.',
    image: '/iv-therapy.jpg',
    features: ['Myers Cocktail', 'Glutathione & Antioxidants', 'NAD+ Boost', 'Hydration & Recovery Blends'],
    category: 'wellness',
    badge: null
  }
];

export const TEAM = [
  {
    id: 1,
    name: 'Angela Trias, M.D.',
    title: 'Founder & Medical Director',
    credentials: 'Board-Certified Family Medicine · Dermatology & Aesthetics · Azova Dermatology Fellowship',
    bio: 'Angie Andreina Trias Sanchez, M.D., is a board-certified Family Medicine physician who specialised in dermatology and aesthetics, and completed an Azova Fellowship in Dermatology. She brings 5 years of urgent care expertise alongside 18 years of clinical experience overall — a whole-person foundation she now channels into aesthetic and precision care at Akira. Born and raised in Venezuela and a second-generation physician, she is passionate about wellness, disease prevention, and empowering patients to take an active role in their health.',
    image: '/dr-angie.jpg',
    specialties: ['XERF RF Tightening', 'Injectable Artistry', 'RF Microneedling', 'Regenerative Therapy'],
    education: 'MD (2008) · Board-Certified Family Medicine · Azova Fellowship in Dermatology · Aesthetic Medicine',
    badge: 'Medical Director'
  },
  {
    id: 2,
    name: 'Erika Tajra, MBBS, MSc',
    title: 'Independent Scientific & Educational Consultant — Translational and Personalised Medicine',
    credentials: "MBBS, St George's, University of London · MSc, University College London",
    bio: "Erika Tajra is an internationally educated physician and specialist educator in translational and personalised medicine. She holds an MBBS from St George's, University of London, and an MSc in Personalised Medicine and Novel Therapies from University College London's Great Ormond Street Institute of Child Health.\n\nThrough her independent education and consultancy company, incorporated and based in Ireland, Erika Tajra provides professional education and scientific advisory services to physicians and healthcare organisations worldwide.\n\nHer role with Akira Signature Care is strictly non-clinical and limited exclusively to general professional education for Akira's California-licensed clinicians. She does not provide patient care, review individual patient information, recommend treatment, prescribe or order tests or therapies, or participate in clinical decisions.",
    bioDisclaimer: 'Erika Tajra is not licensed to practise medicine in California. All patient care and clinical decisions at Akira Signature Care are provided exclusively by appropriately licensed California healthcare professionals.',
    image: '/dr-erika.jpg',
    specialties: ['Translational Medicine Education', 'Personalised Medicine', 'Scientific Advisory', 'Novel Therapies'],
    education: "St George's, University of London (MBBS) · University College London (MSc)",
    badge: 'Scientific & Educational Consultant'
  },
  {
    id: 3,
    name: 'Kelly Chang',
    title: 'Aesthetic Nurse',
    credentials: 'RN · 4 Years in Medical Aesthetics',
    bio: "Kelly is a registered nurse with experience in critical care and medical aesthetics. She's been in the medspa industry for almost 4 years, specializing in dermal fillers, neurotoxins, biostimulators, laser treatments for pigmentation, and skin tightening procedures. She's passionate about creating natural, balanced results that enhance each patient's unique beauty rather than changing it. Fluent in English, Korean, and Mandarin, she understands that beauty is perceived differently across cultures and ethnicities, and believes every treatment should be thoughtfully tailored to each individual's features, goals, and comfort level.",
    image: '/kelly-chang.jpg',
    specialties: ['Dermal Fillers', 'Neurotoxins', 'Biostimulators', 'Laser Pigmentation & Skin Tightening']
  },
  {
    id: 4,
    name: 'Ashlyn Mok',
    title: 'Aesthetic Nurse Injector',
    credentials: 'RN · MSN, University of San Francisco',
    bio: "Ashlyn is an aesthetic registered nurse with a Master of Science in Nursing degree from the University of San Francisco. She has a strong passion for aesthetic medicine and loves helping patients feel confident, refreshed, and like the best version of themselves through natural-looking results. She combines advanced clinical knowledge with an artistic eye to create personalized treatment plans tailored to each patient's unique features, facial anatomy, and goals. Aesthetic medicine is more than just enhancing appearances; it's also about empowering patients, building confidence, and helping people feel their best both inside and out. As a nurse injector, her goal is to provide safe, thoughtful, and results-driven care while creating a comfortable and supportive experience for every patient.",
    image: '/ashlyn-mok.jpg',
    specialties: ['Nurse Injector', 'Personalised Treatment Planning', 'Facial Anatomy & Aesthetics', 'Patient-Centered Care']
  }
];

export const TESTIMONIALS = [
  {
    id: 1,
    name: 'Jennifer L.',
    location: 'Alhambra, CA',
    rating: 5,
    treatment: 'Botox & Lip Filler',
    review: 'I have been coming to Akira Signature Care for over two years and I cannot imagine going anywhere else. Angela Trias has an incredible eye for natural results — I look refreshed, never overdone. The entire team makes you feel so welcome and pampered.',
    avatar: 'JL',
    date: '2 weeks ago'
  },
  {
    id: 2,
    name: 'Michelle T.',
    location: 'Pasadena, CA',
    rating: 5,
    treatment: 'HydraFacial Series',
    review: "My skin has never looked better! After just three HydraFacial sessions, friends keep asking what I'm doing differently. The clinic is immaculate, the staff is knowledgeable, and the results speak for themselves. Absolutely worth every penny.",
    avatar: 'MT',
    date: '1 month ago'
  },
  {
    id: 3,
    name: 'Angela K.',
    location: 'San Gabriel, CA',
    rating: 5,
    treatment: 'Full Body Massage',
    review: "The therapeutic massage here is unlike anything I've experienced. I came in with serious tension from work stress and left feeling completely restored. The therapist was intuitive, skilled, and professional. I've already booked my next appointment!",
    avatar: 'AK',
    date: '3 weeks ago'
  },
  {
    id: 4,
    name: 'Diana R.',
    location: 'Monterey Park, CA',
    rating: 5,
    treatment: 'Microneedling with PRP',
    review: 'I struggled with acne scarring for years and was hesitant to try treatments. The team here was so patient in explaining the process and the results have been truly transformative. My skin texture is dramatically improved. Five stars is not enough!',
    avatar: 'DR',
    date: '1 month ago'
  },
  {
    id: 5,
    name: 'Sophia W.',
    location: 'Arcadia, CA',
    rating: 5,
    treatment: 'IV Vitamin Therapy',
    review: 'I was skeptical about IV therapy but after my first Myers Cocktail session, I was converted. My energy levels skyrocketed and my skin looked so radiant for weeks. The staff is incredibly professional and the atmosphere is so luxurious.',
    avatar: 'SW',
    date: '2 months ago'
  }
];

export const TECHNOLOGIES = [
  {
    id: 'xerf',
    name: 'XERF',
    brand: 'by Cynosure Lutronic',
    badge: 'FDA Cleared',
    tagline: 'Structural Skin Tightening',
    headline: "The world's first multifrequency monopolar RF treatment",
    description: "XERF delivers radiofrequency energy using two simultaneous frequencies — 6.78 MHz and 2 MHz — targeting the shallow, middle, and deep layers of skin exactly where change begins. No numbing. No needles. No downtime.",
    type: 'Radiofrequency (RF)',
    energy: 'Electromagnetic',
    target: 'Dermis → SMAS',
    mechanism: [
      'Uses dynamic temperature control to safely heat up to 42°C, targeting the dermis and SMAS layer',
      'Wave Fit™ pulse controls energy delivery in real time',
      'Advanced Integrated Cryogen Delivery keeps the surface comfortable',
      'Never-Numb™ technology — no topical anesthetic required',
      'Accurate Impedance Feedback adapts to each patient\'s unique skin'
    ],
    benefits: ['Jawline tightening', 'Reduced skin laxity', 'Smoother skin', 'No downtime', 'Cheek & jaw contouring', 'Collagen remodeling'],
    depths: [
      { label: 'Shallow', depth: '1–2 mm', layer: 'Epidermis / Dermis' },
      { label: 'Middle', depth: '2–4 mm', layer: 'Deep Dermis' },
      { label: 'Deep', depth: '4–6 mm', layer: 'SMAS (surgical layer)' },
    ],
    sessions: '2 initial sessions, then 1 yearly',
    downtime: 'None',
    costRange: '$600 – $1,500',
    bestFor: 'Ages 35–60 with early to moderate skin laxity',
    image: 'https://www.cynosure.com/wp-content/uploads/2025/07/1920x720_after2tx_quibell.png',
    beforeAfter: {
      before: 'https://www.cynosure.com/wp-content/uploads/2025/07/1920x720_before_quibell.png',
      after: 'https://www.cynosure.com/wp-content/uploads/2025/07/1920x720_after2tx_quibell.png',
      credit: 'Before & after 2 treatments — Courtesy of Dianne Quibell, MD'
    },
    color: 'rose',
    accent: '#C4897A'
  },
  {
    id: 'microneedling',
    name: 'Microneedling',
    brand: 'Collagen Induction Therapy',
    badge: 'Gold Standard',
    tagline: 'Texture & Renewal',
    headline: 'Controlled micro-injury that unlocks your skin\'s own healing power',
    description: "Microneedling creates thousands of precise micro-channels in the skin, triggering the body's natural wound-healing cascade. At Akira, we enhance results by combining with PRP, peptides, and growth factors for amplified collagen production.",
    type: 'Mechanical + Biological',
    energy: 'Mechanical',
    target: 'Superficial (0.25–2.5 mm)',
    mechanism: [
      'Ultra-fine needles create controlled micro-injuries in the dermis',
      'Fibroblast activation triggers collagen Type I & III production',
      'Optional PRP infusion delivers growth factors into micro-channels',
      'Peptides and serums penetrate 80% deeper than topical application',
      'Progressive texture improvement over a series of treatments'
    ],
    benefits: ['Acne scar reduction', 'Pore minimization', 'Skin texture refinement', 'Mild tightening', 'Hyperpigmentation', 'Enhanced product absorption'],
    depths: [
      { label: 'Light', depth: '0.25–0.5 mm', layer: 'Epidermis' },
      { label: 'Medium', depth: '0.5–1.5 mm', layer: 'Papillary Dermis' },
      { label: 'Deep', depth: '1.5–2.5 mm', layer: 'Reticular Dermis' },
    ],
    sessions: '3–6 sessions (4–6 wks apart)',
    downtime: '24–48 hours',
    costRange: '$200 – $600',
    bestFor: 'All skin types, acne scars, texture concerns',
    image: 'https://images.pexels.com/photos/3762871/pexels-photo-3762871.jpeg?w=700&q=80',
    beforeAfter: null,
    color: 'green',
    accent: '#6B8F71'
  }
];


export const CONTACT_INFO = {
  address: '506 North Garfield Avenue, Ste 210',
  city: 'Alhambra, CA 91801',
  phone: '(626) 737-3183',
  bookingUrl: 'https://booking.mangomint.com/589210',
  hours: [
    { day: 'Monday – Friday', time: '11:00 AM – 5:00 PM' },
    { day: 'Weekends', time: 'By Appointment Only' }
  ],
  social: {
    instagram: 'https://www.instagram.com/AKIRASIGNATURECARE',
    tiktok: 'https://www.tiktok.com/@Akirasignaturecare'
  }
};
